// extracted by mini-css-extract-plugin
module.exports = {"mobile_layout":"_21620d3522--mobile_layout--IiXa7"};